import { Capacitor } from '@capacitor/core';

export const isNative = Capacitor.isNativePlatform();
export const platform = Capacitor.getPlatform();

export async function initCapacitor() {
  if (!isNative) return;

  document.body.classList.add('capacitor-mobile');

  const { StatusBar, Style } = await import('@capacitor/status-bar');
  await StatusBar.setStyle({ style: Style.Dark }).catch(() => {});
  if (platform === 'android') {
    await StatusBar.setBackgroundColor({ color: '#13120A' }).catch(() => {});
  }

  const { SplashScreen } = await import('@capacitor/splash-screen');
  await SplashScreen.hide().catch(() => {});

  const { Keyboard } = await import('@capacitor/keyboard');
  Keyboard.addListener('keyboardWillShow', () => {
    document.body.classList.add('keyboard-open');
  });
  Keyboard.addListener('keyboardWillHide', () => {
    document.body.classList.remove('keyboard-open');
  });

  const { App } = await import('@capacitor/app');
  App.addListener('appUrlOpen', ({ url }) => {
    try {
      const parsed = new URL(url);
      const path = parsed.pathname + parsed.search;
      if (path && path !== '/') {
        window.location.assign(path);
      }
    } catch {
      // ignore malformed URLs
    }
  });
}
